import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { useClearCache } from "react-clear-cache";
import "./i18n";
import { store } from "./Redux/store";
import "./index.scss";
import App from "./App";
import { refreshPermissions } from "./helpers";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://2117caa4ee75da0dc181027fbd256b61@o4510425472565248.ingest.de.sentry.io/4510894511226960",
  });
}

refreshPermissions();

const AppWithCacheBust = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCache();
  if (!isLatestVersion) {
    // console.log(`isLatestVersion: ${isLatestVersion} >> Refreshing `);
    emptyCacheStorage();
    return null;
  }
  return <App />;
};

ReactDOM.render(
  <Provider store={store}>
    <AppWithCacheBust />
  </Provider>,
  document.getElementById("root")
);
unregisterServiceWorker();
